<div class="d-flex">
  <div>
    <app-superadminsidenav></app-superadminsidenav>
  </div>
  <div style="
    height: 100vh;
    overflow: scroll;
    width: 100%;
    background-color: rgba(250, 250, 250, 1);
  ">
    <div style="padding-left: 10px" class="container">
      <div>
        <div class="heading">Weekly Top Ten Restaurants</div>

        <div class="table-main-div" >
          <div *ngIf="topTenData.length == 0" class="empty-list-msg">
            No restaurant in top ten list
          </div>
          <table mat-table [dataSource]="topTenTableData" class="mat-elevation-z8 demo-table" *ngIf="topTenData.length > 0">
            <!-- Position Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef class="table-head checking">
                SL No.
              </th>
              <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                {{ i + 1 }}
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="table-head checking">
                Restaurants Name
              </th>
              <td mat-cell *matCellDef="let element" class="table-element">
                {{ element.restaurant_name }}
              </td>
            </ng-container>


            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="table-head action-th checking">
                Drop
              </th>
              <td mat-cell *matCellDef="let element; let i=index" class="table-element action-element">
                <img src="../../../assets/images/deletIcon.png" alt="" (click)="dropFromList(element , i )"
                  style="cursor: pointer;" />
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="topTenTableDataDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: topTenTableDataDisplayedColumns" class="table-body"></tr>
          </table>
        </div>
        <!-- <div class="update-list-btn-div">
          <button>Update Top Ten List</button>
        </div> -->
      </div>
      <div>
        <div class="heading">List of All Restaurants</div>
        <div class="table-main-div">
          <div>
            <div class="container-head">
              <span class="noOfRestoList"> {{noOfResoData}} Restaurants</span>
              <span class="resto-input">
                <div style="padding: 2px">
                  <img src="../../../assets/images/Search.png" alt="" />
                  <input placeholder="Search with restaurant name " [(ngModel)]="searchText" (ngModelChange)="filter()" />
                </div>
              </span>
            </div>
          </div>
          <div >
            <table mat-table [dataSource]="allTableData" class="mat-elevation-z8 demo-table">
              <!-- Position Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  SL No.
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                  {{ i + 1 }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  Restaurants Name
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                  {{ element.restaurant_name }}
                </td>
              </ng-container>


              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="table-head action-th checking">
                  Add
                </th>
                <td mat-cell *matCellDef="let element;let i = index" class="table-element action-element">
                  <img src="../../../assets/images/add-square-svgrepo-com.svg" alt="" (click)="addToList(element , i)"
                    style="cursor: pointer; max-width: 27px;" />
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="allTableDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: allTableDisplayedColumns"></tr>
            </table>
            <mat-paginator #paginator [pageSizeOptions]="[12, 20,25,50,100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>